<script>
    import { createEventDispatcher } from 'svelte'
    import searchlogo from '../../../assets/pictures/search.svg'
    export let value = ''
    export let placeholder = 'Search...'
    export let disabled = false
    const dispatch = createEventDispatcher()
    function onKeypress(e) {
        dispatch('keypress', { event: e })
    }
    function onInput(e) {
        dispatch('input', { event: e })
    }
    function onKeyup(e) {
        dispatch('keyup', { event: e })
    }
    function onChange(e) {
        dispatch('change', { event: e })
    }
</script>

<div class="search" class:disabled>
    <span>
        <img src={searchlogo} alt="" draggable="false" />
    </span>
    <input
        type="search"
        {placeholder}
        {disabled}
        bind:value
        on:input={onInput}
        on:keypress={onKeypress}
        on:keyup={onKeyup}
        on:change={onChange}
    />
</div>

<style>
    .search {
        width: 100%;
        height: 72px;
        position: relative;
        display: flex;
        flex-direction: row;
        /* gap: 15px; */
        align-items: center;
        /* padding: 0 25px; */
        justify-content: flex-start;
    }
    .search span {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 25px;
        justify-content: center;
    }
    .search input {
        border-style: none;
        outline: none;
        font-size: 17px;
        width: 100%;
    }
    .disabled {
        opacity: 0.75;
        user-select: none;
    }
    input[type='search'] {
        background-color: inherit;
    }
</style>
